import { render, staticRenderFns } from "./VFAs.vue?vue&type=template&id=6dbb2b0d"
import script from "./VFAs.vue?vue&type=script&lang=js"
export * from "./VFAs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports